import { render } from "./SystemsGroupItem.vue?vue&type=template&id=7d1c9abc"
import script from "./SystemsGroupItem.vue?vue&type=script&lang=js"
export * from "./SystemsGroupItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__